import React from 'react';
import { motion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  delay?: number;
  y?: number;
  className?: string;
  as?: 'div' | 'section' | 'li' | 'figure' | 'article';
};
export function Reveal({
  children,
  delay = 0,
  y = 24,
  className = '',
  as = 'div'
}: RevealProps) {
  const MotionTag = motion[as];
  return <MotionTag className={className} initial={{
    opacity: 0,
    y
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-12% 0px -10% 0px'
  }} transition={{
    duration: 1.1,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-142" data-mp="3gitk6io2w77m">
      {children}
    </MotionTag>;
}